

const API_SAVE_ANNOTATION_REQUEST = 'API_SAVE_ANNOTATION_REQUEST';
const API_SAVE_ANNOTATION_SUCCESS = 'API_SAVE_ANNOTATION_SUCCESS';
const API_SAVE_ANNOTATION_FAILURE = 'API_SAVE_ANNOTATION_FAILURE';

const API_SAVE_SMALL_ANNOTATION_REQUEST = 'API_SAVE_SMALL_ANNOTATION_REQUEST';
const API_SAVE_SMALL_ANNOTATION_SUCCESS = 'API_SAVE_SMALL_ANNOTATION_SUCCESS';
const API_SAVE_SMALL_ANNOTATION_FAILURE = 'API_SAVE_SMALL_ANNOTATION_FAILURE';

const API_LEARNER_ANNOTATIONS_REQUEST = 'API_LEARNER_ANNOTATIONS_REQUEST';
const API_LEARNER_ANNOTATIONS_SUCCESS = 'API_LEARNER_ANNOTATIONS_SUCCESS';
const API_LEARNER_ANNOTATIONS_FAILURE = 'API_LEARNER_ANNOTATIONS_FAILURE';
const RESET_LEARNER_ANNOTATION = 'RESET_LEARNER_ANNOTATION';

const ADD_PATH_TO_SAVE_ANNOTATION = 'ADD_PATH_TO_SAVE_ANNOTATION';
const RESET_PATH_TO_SAVE_ANNOTATION = 'RESET_PATH_TO_SAVE_ANNOTATION';

const SELECT_ANNOTATION_SAVE = 'SELECT_ANNOTATION_SAVE';

const RESET_SAVE_EDIT_ANNOTATION = 'RESET_SAVE_EDIT_ANNOTATION';

const API_OVERWRITE_ANNOTATIONS_REQUEST = 'API_OVERWRITE_ANNOTATIONS_REQUEST';
const API_OVERWRITE_ANNOTATIONS_SUCCESS = 'API_OVERWRITE_ANNOTATIONS_SUCCESS';
const API_OVERWRITE_ANNOTATIONS_FAILURE = 'API_OVERWRITE_ANNOTATIONS_FAILURE';
const RESET_OVERWRITE_ANNOTATION = 'RESET_OVERWRITE_ANNOTATION';

export const overwriteAnnotationRequest = () => ({
  type: API_OVERWRITE_ANNOTATIONS_REQUEST,
});
export const overwriteAnnotationSuccess = payload => ({
  type: API_OVERWRITE_ANNOTATIONS_SUCCESS,
  payload,
});
export const overwriteAnnotationFailure = payload => ({
  type: API_OVERWRITE_ANNOTATIONS_FAILURE,
  payload,
});

export const resetOverwriteAnnotation = () => ({
  type: RESET_OVERWRITE_ANNOTATION,
});

export const resetSaveEditForm = () => ({
  type: RESET_SAVE_EDIT_ANNOTATION,
});

export const selectAnnotationSave = payload => ({
  type: SELECT_ANNOTATION_SAVE,
  payload,
});

export const addPathToSaveAnnotation= payload => ({
  type: ADD_PATH_TO_SAVE_ANNOTATION,
  payload,
});

export const resetPathToSaveAnnotation = () => ({
  type: RESET_PATH_TO_SAVE_ANNOTATION,
});

export const resetLearnerAnnotation= () => ({
  type: RESET_LEARNER_ANNOTATION,
});
export const saveAnnotationRequest = () => ({
  type: API_SAVE_ANNOTATION_REQUEST,
});

export const saveAnnotationSuccess = payload => ({
  type: API_SAVE_ANNOTATION_SUCCESS,
  payload,
});
export const saveAnnotationFailure = payload => ({
  type: API_SAVE_ANNOTATION_FAILURE,
  payload,
});

export const saveAnnotationSmallRequest = () => ({
  type: API_SAVE_SMALL_ANNOTATION_REQUEST,
});

export const saveAnnotationSmallSuccess = payload => ({
  type: API_LEARNER_ANNOTATIONS_SUCCESS,
  payload,
});
export const saveAnnotationSmallFailure = payload => ({
  type: API_SAVE_ANNOTATION_FAILURE,
  payload,
});

export const learnerAnnotationsRequest = () => ({
  type: API_LEARNER_ANNOTATIONS_REQUEST,
});

export const learnerAnnotationsSuccess = payload => ({
  type: API_LEARNER_ANNOTATIONS_SUCCESS,
  payload,
});

export const learnerAnnotationsFailure = payload => ({
  type: API_LEARNER_ANNOTATIONS_FAILURE,
  payload,
});

const initialState = {
  isOverwriteAnnotation: null,
  overwriteAnnotationFetching: false,
  pathToSaveAnnotation: null,
  saveAnnotationFetching: false,
  isAnnotationSaved: null,
  printReportFetching: false,
  AnnotationsPdf: null,
  selectedAnnotationId: null,
  isFetched: false,
  fetching: false,
  error: null,
  learnerAnnotations: null,
};

export function annotationsReducer(state = initialState, action) {
  
  switch (action.type) {
    case RESET_OVERWRITE_ANNOTATION:
      return {
        ...state,
        isOverwriteAnnotation: null,
        overwriteAnnotationFetching: false,
        saveAnnotationFetching: false,
        error: null,
      };
    case API_OVERWRITE_ANNOTATIONS_REQUEST:
      return {
        ...state,
        overwriteAnnotationFetching: true,
        saveAnnotationFetching: false,
      };
    case API_OVERWRITE_ANNOTATIONS_SUCCESS:
      return {
        ...state,
        overwriteAnnotationFetching: false,
        isOverwriteAnnotation: action.payload,
        saveAnnotationFetching: false,
        error: null,
      };
    case API_OVERWRITE_ANNOTATIONS_FAILURE:
      return {
        ...state,
        overwriteAnnotationFetching: false,
        saveAnnotationFetching: false,
        error: action.payload,
      };
    case RESET_PATH_TO_SAVE_ANNOTATION:
      return {
        ...state,
        pathToSaveAnnotation: null,
        saveAnnotationFetching: false,
      };
    case RESET_LEARNER_ANNOTATION:
      return {
        ...state,
        isFetched: false,
        saveAnnotationFetching: false,
        learnerAnnotations: null,
      };
    case RESET_SAVE_EDIT_ANNOTATION:
      return {
        ...state,
        isAnnotationSaved: null,
        saveAnnotationFetching: false,
        error: null,
      };
    case SELECT_ANNOTATION_SAVE:
      
      return {
        ...state,
        learnerAnnotations: action.payload,
        saveAnnotationFetching: false,
      };
    case ADD_PATH_TO_SAVE_ANNOTATION:
      return {
        ...state,
        pathToSaveAnnotation: action.payload,
        saveAnnotationFetching: false,
      };
    case API_SAVE_ANNOTATION_REQUEST:
        
      return {
        ...state,
        saveAnnotationFetching: true,
      };
    case API_SAVE_ANNOTATION_SUCCESS:
      return {
        ...state,
        saveAnnotationFetching: false,
        isAnnotationSaved: action.payload,
        error: null,
      };
    case API_SAVE_ANNOTATION_FAILURE:
      return {
        ...state,
        saveAnnotationFetching: false,
        error: action.payload,
      };

      case API_SAVE_SMALL_ANNOTATION_REQUEST:
          
        return {
          ...state,
          saveAnnotationFetching: true,
        };
      case API_SAVE_SMALL_ANNOTATION_SUCCESS:
        return {
          ...state,
          saveAnnotationFetching: false,
          isAnnotationSaved: action.payload,
          error: null,
        };
      case API_SAVE_SMALL_ANNOTATION_FAILURE:
        return {
          ...state,
          saveAnnotationFetching: false,
          error: action.payload,
        };
    
    case API_LEARNER_ANNOTATIONS_REQUEST:
      return {
        ...state,
        fetching: true,
        saveAnnotationFetching: false,
      };
    case API_LEARNER_ANNOTATIONS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        error: null,
        learnerAnnotations: action.payload,
        saveAnnotationFetching: false,
      };
    case API_LEARNER_ANNOTATIONS_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: true,
        error: action.payload,
        learnerAnnotations: null,
        saveAnnotationFetching: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/annotations.js